<div class="attachments">
  <ng-template
    *ngIf="(modeData.currentMode$ | async).edit; then editMode; else viewMode"></ng-template>

  <ng-template #editMode>
    <button
      mat-button
      class="show-attachments orgModel-icon"
      [matTooltip]="'HINTS.SHOW_ATTACHMENTS' | translate"
      [matTooltipPosition]="'above'"
      (click)="openAttachments()">
      <mat-icon svgIcon="sf_orgs"></mat-icon>
    </button>
  </ng-template>

  <ng-template #viewMode>
    <button
      *ngIf="(source.orgModelAttachments | userGroupsFilter: userGroups : isProSpace).length"
      mat-button
      class="show-attachments orgModel-icon"
      [matTooltip]="'HINTS.SHOW_ATTACHMENTS' | translate"
      [matTooltipPosition]="'above'"
      [matTooltipDisabled]="orgModelsOpened"
      [matMenuTriggerFor]="salesMenu"
      (click)="openMenu()">
      <mat-icon svgIcon="sf_orgs"></mat-icon>
    </button>
  </ng-template>

  <mat-menu #salesMenu="matMenu" (closed)="onMenuClose()" overlapTrigger="true" class="paperclip">
    <div
      *ngFor="
        let item of source.orgModelAttachments | userGroupsFilter: userGroups : isProSpace;
        trackBy: track
      ">
      <button mat-menu-item [disableRipple]="true" (click)="openSingleAttachment(item)">
        <mat-icon svgIcon="sf" class="paperclip__icon without-stroke-width"></mat-icon>

        <span
          class="paperclip__title"
          [matTooltip]="item.title | decodeHtml"
          [matTooltipPosition]="'right'"
          [matTooltipDisabled]="item.title.length < 22">
          {{ item.title | decodeHtml }}
        </span>
      </button>
    </div>
  </mat-menu>
</div>
